import { createContext } from 'react';

const ChatContext = createContext(null);
export default ChatContext;
